import { useContext } from "react";

import { AbilityContext } from "context/Ability.context";

export function useAbility() {
  return useContext(AbilityContext);
}
